<template>
    <x-container grid-list-lg fluid app-width>
        <x-layout mt-3>
            <x-flex xs12 text-xs-right>
                <x-btn
                    key="open-modal"
                    class="ma-0 ml-3 mt-3"
                    depressed
                    @click="openModal"
                >
                    Open Modal
                </x-btn>
            </x-flex>
        </x-layout>
        <modal
            ref="idleModalView"
            title="Session expire warning"
            confirmation
            action-text="Extend"
            cancel-text="Logout"
        >
            <x-layout mt-4>
                <x-flex xs10 class="right-border">
                    <p>Your session is about to expire due to inactivity and will log you out automatically.</p>
                    <p>Please choose to extend your session or logout.</p>
                </x-flex>
                <x-flex xs2>
                    <div class="base-timer">
                        <span class="base-timer__label" :class="remainingPathColor">
                            {{ formattedTimeLeft }}
                        </span>
                    </div>
                </x-flex>
            </x-layout>
        </modal>
    </x-container>
</template>
<script>
import Modal from '~/components/Shared/UIComponents/Modal';

export default {
    name: 'IdleModal',
    components: {
        Modal,
    },
    data() {
        return {
            timeLimit: 60 * 5,
            timePassed: 0,
            timerInterval: null,
            alertThreshold: 20,
            warningThreshold: 60,
        }
    },
    computed: {
        timeLeft() {
            return this.timeLimit - this.timePassed
        },
        colorCodes() {
            return {
                info: {
                    color: "green-color"
                },
                warning: {
                    color: "orange-color",
                    threshold: this.warningThreshold
                },
                alert: {
                    color: "red-color",
                    threshold: this.alertThreshold
                }
            }
        },
        formattedTimeLeft() {
            const {timeLeft} = this
            if (timeLeft < 0) {
                this.logout();
                return `00:00`;
            }
            //The largest round integer less than or equal
            //to the result of time divided being by 60.
            let minutes = Math.floor(timeLeft / 60)
            // If the value of minutes is less than 10,
            //then display minutes with a leading zero
            if (minutes < 10) {
                minutes = `0${minutes}`
            }
            // Seconds are the remainder of the time divided
            //by 60 (modulus operator)
            let seconds = timeLeft % 60
            // If the value of seconds is less than 10,
            //then display seconds with a leading zero
            if (seconds < 10) {
                seconds = `0${seconds}`
            }
            // The output in MM:SS format
            return `${minutes}:${seconds}`
        },
        remainingPathColor() {
            const { alert, warning, info } = this.colorCodes;

            if (this.timeLeft <= alert.threshold) {
                return alert.color;
            } else if (this.timeLeft <= warning.threshold) {
                return warning.color;
            }

            return info.color;
        }
    },
    mounted() {
        this.openModal();
        this.startTimer();
    },
    methods: {
        startTimer() {
            this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
        },
        async openModal() {
            if (await this.$refs.idleModalView.open() === false) {
                this.logout();
                return;
            }

            this.resetInterval();
            this.$hyperionAuth.refreshAccessToken();
            this.$eventBus.$emit('exiting-window', true);
        },
        resetInterval() {
            clearInterval(this.timerInterval);
            this.timeLimit = 30;
            this.timePassed = 0;
        },
        logout() {
            this.$hyperionAuth.logout();
            this.resetInterval();
            this.$eventBus.$emit('exiting-window', true);
            this.$router.push({ name: 'login' });
        },
    }
}
</script>

<style lang="scss">
.right-border {
    border-right: 1px solid;
}

.base-timer {
    position: relative;
    width: 100%;
    height: 100px;

    display: flex;
    align-items: center;
    justify-content: center;

    &__label {
        top: 0;
        font-size: 30px;
        width: 80px;
        text-align: left;

        &.green-color {
            color: $color-green
        }

        &.orange-color {
            color: $color-orange;
        }

        &.red-color {
            color: $color-red;
        }
    }
}
</style>
